import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Биология. 6 класс.",
        subject: "Лист и стебель как органы дыхания",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Лист и стебель как органы дыхания",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Овчинников Алексей Васильевич",
                grade: "кандидат педагогических наук",
                subGrade: "",
                imageSrc: "./images/author1.jpg"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<p style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>В ходе данного методического кейса рассматриваются различные способы достижения образовательных результатов, при изучении дыхания растений и особенностей строения листа и стебля как органов дыхания. Описывается специфика работы по формированию знаний о взаимосвязи дыхания и фотосинтеза. Актуальность данной темы определяется тем, учащиеся, как правило, усваивают только материал о внешнем проявлении дыхания – процессах газообмена и не акцентируют внимание на роли кислорода в обеспечении жизнедеятельности растений энергией. Кроме того, при изучении фотосинтеза и дыхания обучающиеся испытывают трудности в установлении противоположного характера этих процессов. Материалы представленного кейса позволяют избежать данных ошибок.</p>"
                        },
                        {
                            type: "block",
                            listLabel: "В ходе кейса будут рассмотрены:",
                            unorderedList: [
                                "приемы повторения изученного ранее материала и способы актуализации знаний на основе субъективного опыта обучающихся;",
                                "формы работы по формированию функциональной грамотности обучающихся на примерах изучаемого материала;",
                                "различные варианты организации изучения нового материала, закрепления и проверки знаний;",
                                "примеры заданий, позволяющих организовать интерактивное взаимодействие с обучающимися."
                            ]
                        },
                        {
                            type: "block",
                            text: "<p style='padding: 0 2.4rem;'>Формы работы, методы, приемы, представленные в данном кейсе, являются универсальными и могут быть использованы на уроках по другим темам. Конструирование уроков с использованием материалов данного кейса позволяет успешно достигать образовательных результатов, способствует формированию познавательного интереса и внутренней мотивации к изучению биологии.</p>"
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/biology.mp4"
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Лернер И.Я. Дидактические основы методов обучения. – Москва: Педагогика, 1981",
                "Пономарёва Н.И., Корнилова О.А., Кучменко В.С. Биология. Растения. Бактерии. Грибы. Лишайники: Учебник для учащихся 6 класса общеобразовательных учреждений / Под ред. проф. И.Н. Пономарёвой. – Москва: Вентана-Граф, 2005",
                "Трайтак Д.И. Книга для чтения по ботанике. Пособие для учащихся. – Москва: Просвещение, 1978",
                "Хюннинен О.Н. Биология. 6 класс. Опорные схемы: учеб. пособие. – Москва: Дрофа, 2010",
                "Российская электронная школа. Биология. 6 класс. Урок №13: «Дыхание»",
                "Биология : 6-й класс : базовый уровень : учебник / В.В. Пасечник, С.В. Суматохин, З.Г. Гапонюк, Г.Г. Швецов; под ред. В.В. Пасечника. – Москва: Просвещение, 2022 – 160 с."
            ],
            filesToDownload: [
                {
                    link: "./files/biology_material_1.pdf",
                    fileName: "Задания для повторения изученного материала"
                },
                {
                    link: "./files/biology_material_2.pdf",
                    fileName: "Вопросы для контроля знаний "
                },
                {
                    link: "./files/biology_material_3.pdf",
                    fileName: "Задания для формирования и оценки естественно-научной грамотности «Дыхание растений»"
                },
            ]
        }
    ],
};
